import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { ConnectRequestService } from '../../../modules/panel/_services/connect-request.service';
import { ConnectionService } from '../../../modules/panel/_services/connection.service';
import { MessagingService } from '../../../modules/panel/_services/messaging.service';
import { AuthService } from '../../../modules/auth/_services/auth.service';
import { TenantService } from '../../../modules/core/services/tenant.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-aside',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    BadgeModule,
  ],
  templateUrl: './aside.component.html',
  styleUrl: './aside.component.scss'
})
export class AsideComponent implements OnInit {
  fileServerUrl: any = environment.fileServerUrl;
  logoPath = environment.logoWhitePath;
  isActive1: boolean = false;
  isSubMenuVisible1: boolean = false;
  isActive2: boolean = false;
  isSubMenuVisible2: boolean = false;
  subscriptions: Subscription[] = [];
  connectionBadge: number = 0
  messageBadge: number = 0;
  tenant: any;

  constructor(
    private router: Router,
    private connectRequestService: ConnectRequestService,
    private connectionService: ConnectionService,
    private messagingService: MessagingService,
    private tenantService: TenantService,
    public authService: AuthService
  ) {
    tenantService.tenant$.subscribe(x => {
      this.tenant = x;
    })
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkIfSubMenuActive();
      }
    });

    // Initial check
    this.checkIfSubMenuActive();

    this.subscriptions.push(
      this.messagingService.count$.subscribe(count => {
        this.messageBadge = count;
      })
    );

    this.subscriptions.push(
      this.connectionService.pendingCount$.subscribe(count => {
        this.connectionBadge = count;
      })
    );

    this.subscriptions.push(
      this.connectRequestService.pendingCount$.subscribe(count => {
        this.connectionBadge = count;
      })
    );
  }

  toggleSubMenu(index: number) {
    if (index === 1) {
      this.isSubMenuVisible1 = !this.isSubMenuVisible1;
    } else if (index === 2) {
      this.isSubMenuVisible2 = !this.isSubMenuVisible2;
    }
  }

  private checkIfSubMenuActive() {
    const currentUrl = this.router.url;
    this.isActive1 = currentUrl.startsWith('/panel/founder/lms');
    this.isSubMenuVisible1 = this.isActive1;

    this.isActive2 = currentUrl.startsWith('/panel/founder/network');
    this.isSubMenuVisible2 = this.isActive2;
  }

}
